const selector = {
  buttonToggle: '.js-ingredient-toggle',
  buttonClose: '.js-ingredient-close'
}

const classes = {
  active: 'is-active',
  showSlideOut: 'is-showing-ingredients-slideout',
}

export default () => {
  const toggleButtons = [...document.querySelectorAll(selector.buttonToggle)]

  if (toggleButtons.length) {
    toggleButtons.forEach(button => {
      button.addEventListener('click', openSlideOut.bind(this))
    })
  }

  function openSlideOut(event) {
    const current = event.currentTarget
    const sideOut = document.querySelector(`#${current.dataset.target}`)

    if (sideOut) {
      sideOut.classList.add(classes.active)
      document.body.classList.add(classes.showSlideOut)

      closeSlideOut(sideOut)
    }
  }

  function closeSlideOut(el) {
    if (!el) {
      return
    }

    const buttonClose = el.querySelectorAll(selector.buttonClose)

    if (buttonClose) {
      buttonClose.forEach(button => {
        button.addEventListener('click', () => {
          el.classList.remove(classes.active)
          document.body.classList.remove(classes.showSlideOut)
        })
      })
    }
  }
}